import { ToastProvider } from '@nimbus-ds/components';
import { ErrorBoundary } from '@tiendanube/nexo';
import '@nimbus-ds/styles/dist/index.css';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './i18n/index.js';
import nexo from './nexoClient.js';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

// Nexo ErrorBoundary at the top of the tree (per the official guidance) reports render
// errors back to the admin. ToastProvider enables Nimbus toasts app-wide.
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary nexo={nexo}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </StrictMode>,
);
